import React, { useEffect, useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';
import {
  Configure,
  InfiniteHits,
  useClearRefinements,
  useDynamicWidgets,
  useHits,
  useInfiniteHits,
  useInstantSearch,
  useSearchBox,
} from 'react-instantsearch-hooks-web';
import { BreadCrumb } from 'shared/types/content/BreadCrumb';
import { Category } from 'shared/types/product/Category';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import Link from 'components/commercetools-ui/atoms/link';
import Wrapper from 'components/HOC/wrapper';
import { mapProduct } from 'helpers/algolia/map-product';
import { PLP_PRODUCT_CLICKED } from 'helpers/constants/events';
import { useFormat } from 'helpers/hooks/useFormat';
import useLocale from 'helpers/hooks/useLocale';
import AccumalativeTrace from './components/accumalative-trace';
import Breadcrumbs from './components/breadcrumb';
import CurrentRefinements from './components/current-refinements';
import DesktopFacets from './components/desktop-facets';
import FacetUI from './components/facets/facet-ui';
import MobileFacets from './components/mobile-facets';
import SearchHeader from './components/search-header';
import { BottomContentDescription, FacetConfiguration, ProductListingContent } from './types';
import Faq from '../product-list/components/FAQ';
import ProductTile from '../product-tile';
import ProductListTile from './components/productList-tile';
import { ChevronRightIcon as ArrowIcon } from '@heroicons/react/24/solid';
import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import FaqAmplience from '../product-list/components/FAQ/faqAmplience';
import { searchClient } from 'algolia/searchClient';
import { Range } from 'react-range';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import Modal from 'components/commercetools-ui/atoms/modal';
import Prices from '../product-tile/prices';
import beforeCompare from 'public/locales/en/product.json';
import { useRouter } from 'next/navigation';
import { InstantSearch, RefinementList, RangeInput } from 'react-instantsearch-hooks-web';
import DesktopFacetsUpdate from './components/desktop-facets/desktop-facets-update';
import { useSearchParams } from 'next/navigation';
import { AdjustmentsHorizontalIcon as FiltersIcon } from '@heroicons/react/24/solid';
import SortBy from './components/sort-by';
import NoResults from './components/no-result-found';
import Loading from 'components/commercetools-ui/atoms/loading';
import NotFound from './components/Algolia-search-Page/NotFound';
import Price from './components/Algolia-search-Page/price';
import { DataLayerHelpers, DataLayerOnLoad } from 'helpers/dataLayerHelpers';
import { useCookies } from 'react-cookie';
import { useAccount, useCart } from 'frontastic';
import { lineItems } from 'helpers/mocks/mockCommonData';
import TrustBox from '../../trustpilot';
import { StringHelpers } from 'helpers/stringHelpers';
import { Hit } from 'instantsearch.js';
import { AlgoliaAnalytics } from 'helpers/AlgoliaEvents';

import { attributeMapping } from 'algolia/product-list';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';
import { RangeSlider } from './components/facets/rangeSlider';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { SmartLink } from 'components/commercetools-ui/atoms/loadMoreSmartLink';
declare global {
  interface Window {
    __initialPageTriggerUsed?: boolean;
  }
}
interface Props {
  slug?: string;
  searchQuery?: string;
  categories: Category[];
  facetsConfiguration: Record<string, FacetConfiguration>;
  breadCrumbs?: BreadCrumb[];
  // BrandAndSubCategory?: string;
  categoryContent?: ProductListingContent;
  badgeData: any;
  algoliaData: any;
  indexName: string;
  topAndBottomContent: any;
}
interface Brands {
  brand?: string;
  productsCount?: string;
}

interface SubCategories {
  categoryId?: string;
  name?: string;
  productsCount?: string;
}

type ProductHit = {
  standalonePriceSort?: number;
};

const ProductListAlgolia: React.FC<Props> = ({
  slug,
  searchQuery,
  categories,
  facetsConfiguration,
  breadCrumbs = [],
  // BrandAndSubCategory,
  categoryContent,
  badgeData,
  algoliaData,
  indexName,
  topAndBottomContent,
}) => {
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const { hits, showMore, currentPageHits } = useInfiniteHits();
  const { productList, categorySlug, facets = {}, selectedFilters } = algoliaData;
  const facetAttributesFromServer = Object?.keys(facets);
  const [serverData, setServerData] = useState(productList as Hit[]);
  const { results, setUiState } = useInstantSearch();
  const totalHits = results?.nbHits as any;
  // const [isChanged, setIsChanged] = useState(false);
  // const { ctLocale: locale } = useLocale();
  const { locale } = useLocale();
  const [isExpanded, setIsExpanded] = useState(false);
  const [facetAttributes, setFacetAttributes] = useState([]);
  const category = useMemo(() => categories?.find((category) => category?.slug === slug), [categories, slug]);
  const path = usePathname();
  const [ishits, setIshits] = useState(false);

  const [isClient, setIsClient] = useState(false);
  // const indexName =
  //   locale === 'en' || locale === 'en_GB'
  //     ? process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US
  //     : process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  // let indexName = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US;
  // const hostName = window.location.hostname;
  // if (hostName?.includes('.eu') || hostName?.includes('-eu')) {
  //   indexName = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  // } else if (locale === 'en' || locale === 'en_GB') {
  //   indexName = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US;
  // } else {
  //   indexName = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  // }

  const lowIndex = `${indexName}_price_asc`;
  const highIndex = `${indexName}_price_desc`;
  const [lowPrice, setLowPrice] = useState<number | undefined>(0);
  const [maxPrice, setMaxPrice] = useState<number | undefined>(10);
  const [priceRange, setPriceRange] = useState([lowPrice, maxPrice]);
  const [algoliaMin, setAlgoliaMin] = useState(lowPrice);
  const [algoliaMax, setAlgoliaMax] = useState(maxPrice);
  const [cartDiscountKey, setCartDiscountKey] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [noResults, setNoResults] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [cookies, setCookie] = useCookies(['locale_selection', 'frontastic-session']);
  const [trustPilotSkuId, setTrustPilotSkuId] = useState('');
  const router = useRouter();
  const searchParams = useSearchParams();
  const { result, loggedIn } = useAccount();
  const localeSelection = getCurrencyCookie('locale_selection');
  const currency: string = localeSelection?.currency || null;
  const { attributesToRender } = useDynamicWidgets();

  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  const [compareData, setCompareData] = useState(() => {
    const storedData = sessionStorage.getItem('PLP-Compare');
    return storedData ? JSON.parse(storedData) : { query: pathname, products: [] };
  });

  // let brandAndSubCategory;
  // if (BrandAndSubCategory) {
  //   brandAndSubCategory = JSON?.parse(BrandAndSubCategory as string);
  // }

  const productsToCompare = compareData?.products;

  const currentCategory = useMemo(() => {
    return (categories?.find((category) => category?.categoryId === category?.categoryId) ?? {}) as Category;
  }, [category?.categoryId]);

  const removeProductFromSession = (productKey: string) => {
    setCompareData((prevProducts: any) => {
      const products = prevProducts?.products ?? [];

      const updatedProducts = products?.filter((product: any) => product?.productKey !== productKey);

      const updatedCompareProducts = { query: prevProducts?.query, products: updatedProducts };
      sessionStorage.setItem('PLP-Compare', JSON.stringify(updatedCompareProducts));

      return updatedCompareProducts;
    });
  };

  const comparePage = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('previousUrl', pathname);
    }
    router.push(`/compare`);
  };

  const handleCompareChange = (product: any) => {
    if (compareData?.query !== pathname) {
      setCompareData({ query: pathname, products: [] });
    }

    const isProductInCompareList = compareData?.products?.some((item: any) => item?.productKey === product?.productKey);

    if (isProductInCompareList) {
      setCompareData((prevState: any) => ({
        ...prevState,
        products: prevState?.products.filter((item: any) => item?.productKey !== product?.productKey),
      }));
    } else {
      if (compareData?.products?.length >= 4) {
        alert('You can only compare up to 4 products at a time.');
        return;
      }

      setCompareData((prevState: any) => ({
        ...prevState,
        products: [...prevState?.products, product],
      }));
    }
  };

  const handleOnChange = (values: number[]) => {
    let [newMin, newMax] = values;

    if (newMin < (lowPrice as number)) (newMin as number | undefined) = lowPrice;
    if (newMax > (maxPrice as number)) (newMax as number | undefined) = maxPrice;

    if (newMin === 0 && newMax === 0) return;

    setPriceRange([newMin, newMax]);
  };

  const handleFinalChange = (values: number[]) => {
    let [newMin, newMax] = values;

    newMin = Math.max(lowPrice as number, newMin);
    newMax = Math.min(maxPrice as number, newMax);

    if (newMin > newMax) return;
    setPriceRange([newMin, newMax]);
    setAlgoliaMin(newMin);
    setAlgoliaMax(newMax);
    // const params = new URLSearchParams(searchParams.toString());

    // params.delete('prefn1');
    // params.delete('pmin');
    // params.delete('pmax');

    // params.set('prefn1', 'price');
    // params.set('pmin', (newMin / 100).toFixed(2));
    // params.set('pmax', (newMax / 100).toFixed(2));

    // router.push(`${pathname}?${params.toString()}`);
  };
  useEffect(() => {
    if (hits?.length > 0) {
      setServerData(hits);
      setIshits(true);
    } else if (serverData?.length === 0) {
      setNoResults(true);
    }
  }, [hits, serverData]);
  useEffect(() => {
    const params = new URLSearchParams(searchParams.toString());

    const urlMin = parseFloat(params.get('pmin') || `${(lowPrice as number) / 100}`) * 100;
    const urlMax = parseFloat(params.get('pmax') || `${(maxPrice as number) / 100}`) * 100;

    setPriceRange([urlMin, urlMax]);
    setAlgoliaMin(urlMin);
    setAlgoliaMax(urlMax);
  }, [searchParams, lowPrice, maxPrice]);

  useEffect(() => {
    setCartDiscountKey(searchParams.get('pmid') || '');
  }, [searchParams]);

  const { refine } = useSearchBox();
  useEffect(() => {
    if (cartDiscountKey) {
      refine(cartDiscountKey);
    }
  }, [cartDiscountKey, refine]);

  // useEffect(() => {
  //   setIsLoading(true);
  //   if (!searchClient) return;

  //   const fetchData = async () => {
  //     try {
  //       const index = searchClient.initIndex(indexName as any);
  //       index.getSettings().then((settings) => {
  //         const cleanedAttributes = settings?.attributesForFaceting?.map((attr) =>
  //           attr.replace(/searchable\(|filterOnly\(|\)/g, ''),
  //         );
  //         setFacetAttributes(cleanedAttributes as any);
  //       });

  //       while (!results?.hits) {
  //         await new Promise((resolve) => setTimeout(resolve, 100));
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [slug]);

  useEffect(() => {
    sessionStorage.setItem('PLP-Compare', JSON.stringify(compareData));
  }, [compareData]);

  // useEffect(() => {
  //   if (!searchClient) return;

  //   const fetchPriceLimits = async () => {
  //     try {
  //       const lowPriceIndex = searchClient.initIndex(lowIndex);
  //       const highPriceIndex = searchClient.initIndex(highIndex);
  //       const lowPriceResult = await lowPriceIndex.search<ProductHit>(
  //         cartDiscountKey ? cartDiscountKey : (slug as any),
  //         {
  //           facets: ['*'],
  //           hitsPerPage: 50,
  //         },
  //       );
  //       const highPriceResult = await highPriceIndex.search<ProductHit>(
  //         cartDiscountKey ? cartDiscountKey : (slug as any),
  //         {
  //           facets: ['*'],
  //           hitsPerPage: 1,
  //         },
  //       );
  //       const minPriceHit = lowPriceResult.hits.find((hit: any) => {
  //         return hit?.standalonePriceSort > 0;
  //       });
  //       const minPrice = minPriceHit?.standalonePriceSort;

  //       const maxPriceHit = highPriceResult.hits.find((hit: any) => hit?.standalonePriceSort);
  //       const maxPrice = maxPriceHit?.standalonePriceSort;

  //       if (minPrice !== 0 && maxPrice !== 0) {
  //         setLowPrice(minPrice);
  //         setMaxPrice(maxPrice);
  //         setPriceRange([minPrice, maxPrice]);
  //       } else {
  //         console.error('Invalid price range:', { minPrice, maxPrice });
  //       }
  //     } catch (error) {
  //       console.error('Error fetching price range:', error);
  //     }
  //   };

  //   fetchPriceLimits();
  // }, [slug, cartDiscountKey]);
  // const { refine: clearAllRefinements } = useClearRefinements();
  //   const clearAllFilters = () => {
  //     setUiState((prevState) => ({
  //       ...prevState,
  //       [`${indexName}`]: {
  //         query: '',
  //         refinementList: {}, // ✅ Clears all facets
  //         numericFilters: {}, // ✅ Clears numeric filters
  //       },
  //     }));
  //     const pathName = location.pathname;
  //     router.replace(pathName.split('/shop-by')?.[0]); // ✅ Reset URL
  //   };

  const clearAllFilters = () => {
    setUiState((prevState) => {
      const currentIndexState = prevState[indexName] || {};

      const newIndexState = {
        ...currentIndexState, // Keep existing properties (e.g. sort-by)
        query: '',
        refinementList: {}, // Clears all facets
        numericFilters: {}, // Clears numeric filters
        sortBy: undefined, // Clear sort-by filter explicitly
      };

      const newState = {
        ...prevState,
        [indexName]: newIndexState,
      };
      return newState;
    });

    const pathName = location.pathname;
    // Split into segments (filtering out empty strings for easier handling)
    const segments = pathName.split('/').filter(Boolean);

    // Find the index of the "shop-by" and "sort-by" segments (if they exist)
    const shopIndex = segments.indexOf('shop-by');
    const sortIndex = segments.indexOf('sort-by');

    let newSegments = [...segments]; // Start with the full path segments

    // If "shop-by" exists, remove everything from "shop-by" onwards
    if (shopIndex !== -1) {
      newSegments = newSegments.slice(0, shopIndex);
    }

    // If "sort-by" exists, remove it and everything after it
    if (sortIndex !== -1) {
      newSegments = newSegments.slice(0, sortIndex);
    }

    // Reassemble the path, adding a leading slash
    const newPath = '/' + newSegments.join('/');
    router.replace(newPath); // Replace the URL with the updated path
  };

  // const clearAllFilters = () => {
  //   setUiState((prevState) => {
  //     const currentIndexState = prevState[indexName] || {};
  //     const newIndexState = {
  //       ...currentIndexState, // keep existing properties (e.g. sort-by)
  //       query: '',
  //       refinementList: {}, // clears all facets
  //       numericFilters: {}, // clears numeric filters
  //     };
  //     const newState = {
  //       ...prevState,
  //       [indexName]: newIndexState,
  //     };
  //     return newState;
  //   });

  //   const pathName = location.pathname;
  //   // Split into segments (filtering out empty strings for easier handling)
  //   const segments = pathName.split('/').filter(Boolean);

  //   const shopIndex = segments.indexOf('shop-by');
  //   if (shopIndex !== -1) {
  //     // Look for a "sort-by" segment that appears after "shop-by"
  //     const sortIndex = segments.indexOf('sort-by', shopIndex);

  //     let newSegments;
  //     if (sortIndex !== -1) {
  //       // If "sort-by" exists, keep everything before "shop-by" and then append from "sort-by" onward
  //       newSegments = segments.slice(0, shopIndex).concat(segments.slice(sortIndex));
  //     } else {
  //       // Otherwise, simply keep everything before "shop-by"
  //       newSegments = segments.slice(0, shopIndex);
  //     }

  //     // Reassemble the path, adding a leading slash
  //     const newPath = '/' + newSegments.join('/');
  //     router.replace(newPath);
  //   }
  // };

  // const clearAllFilters = () => {
  //   setClearFilter(true);

  //   clearAllRefinements();
  //   refine('');

  //   router.replace(pathname, undefined);

  //   setTimeout(() => {
  //     setClearFilter(false);
  //     refine(' ');
  //   }, 100);
  // };

  // useEffect(() => {
  //   if (clearFilter) {
  //     refine('');
  //     clearAllRefinements();
  //   }
  // }, [clearFilter, refine, clearAllRefinements]);

  // useEffect(() => {
  //   let interval: NodeJS.Timeout;
  //   let attempts = 0;
  //   const maxAttempts = 3;

  //   if (results) {
  //     setIsLoading(true);

  //     interval = setInterval(() => {
  //       if (results.nbHits > 0) {
  //         setIsLoading(false);
  //         setNoResults(false);
  //         clearInterval(interval);
  //       } else if (attempts >= maxAttempts) {
  //         setIsLoading(false);
  //         setNoResults(true);
  //         clearInterval(interval);
  //       }
  //       attempts++;
  //     }, 500);
  //   }

  //   return () => clearInterval(interval);
  // }, [results.nbHits]);
  const { account } = useAccount();
  const { getCountry, getCurrency } = useLocale();
  const transformItems = useMemo(() => {
    return (items: RefinementListItem[]) => {
      return items
        .map((item) => {
          const formatedLabel = item?.label?.split(' > ') || [];
          const newItem = {
            ...item,
            // value: formatedLabel?.length > 1 ? formatedLabel?.[1] : formatedLabel?.[0],
            label: formatedLabel?.length > 1 ? formatedLabel?.[1] : formatedLabel?.[0],
          };
          return newItem;
        })
        ?.filter((item) => !item?.highlighted?.toLowerCase().includes('brands'))
        ?.filter((item) => !item?.highlighted?.toLowerCase().includes('recently viewed'));
    };
  }, []);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient) {
      const localeData = {
        country: getCountry(),
        currency: getCurrency(),
      };
      const currentUrl = document.location.origin;
      const dataLayer = new DataLayerOnLoad(currentUrl, 'PLP', localeData, account);
      dataLayer.setDataLayerOnLoad();
    }
  }, []);

  useEffect(() => {
    if (results?.hits?.length > 0) {
      const dataLayerPLP = new DataLayerHelpers(path, locale);

      dataLayerPLP.pushImpressionsToDataLayer(
        results?.hits as any,
        breadCrumbs as any,
        cookies?.locale_selection?.currency,
      );
    }
  }, [ishits]);
  const userId = loggedIn ? result?.data?.data?.account?.accountId : localStorage.getItem('__anon_id');
  const handleClickLoadMore = (locale: string) => {
    // const localeField = locale === 'en' ? 'en-GB' : 'en-EU';
    const objectIDs = serverData.map((item) => item?.objectID);
    const analytics = new AlgoliaAnalytics(locale);
    analytics.handleClickLoadMore(objectIDs, userId);
  };

  const filteredAttributes = attributesToRender?.filter((attr) => facetAttributesFromServer.includes(attr));
  const priceAttributes = currency === 'GBP' ? 'standalonePrice.priceGB' : 'standalonePrice.priceEU';

  const limit = 10;
  const showMoreLimit = 30;

  const getFacetCount = (attribute: any) => {
    if (facets?.[attribute]) {
      return Object.keys(facets?.[attribute])?.length;
    }
    return 0;
  };

  const shouldShowMore = (attribute: string) => getFacetCount(attribute) > limit;
  const button = (
    <button
      onClick={() => {
        showMore();
        handleClickLoadMore(locale);
      }}
      disabled={hits?.length >= totalHits}
      className="mx-auto mt-[90px] block rounded-md bg-primary-black px-48 py-12 text-16 font-bold text-white transition hover:bg-gray-500 disabled:bg-neutral-400 disabled:opacity-0"
    >
      LOAD MORE
    </button>
  );
  return (
    <>
      {cartDiscountKey && (
        <div className="mb-20 flex h-[128px] w-full flex-col items-center justify-center gap-y-20 bg-[#00d195] py-15">
          <p className="font-body text-40 font-bold capitalize leading-[22px]">{cartDiscountKey.replace(/-/g, ' ')}</p>
        </div>
      )}
      <div className="product-list-algolia min-h-screen max-w-[80rem] p-[1rem] lg:mx-auto">
        {/* Due to build issue we have commented the below code  */}

        {/* <Configure
                query={searchQuery ?? ''}
                filters={!!category ? `categories.id:${category.categoryId}` : ''}
                maxValuesPerFacet={1000}
            /> */}

        {topAndBottomContent?.topContentDescription?.description && (
          <div className="topContentDescription flex justify-center text-center">
            <div className="mx-auto p-15 sm:w-[500px] md:w-[800px]">
              <MarkDownDescription
                markdownText={topAndBottomContent?.topContentDescription?.description}
                classname=""
              />
            </div>
          </div>
        )}

        {/* As of Now Commentted : Referred  UI from Prod */}
        {/* {searchQuery ? (
          <Wrapper>
            <SearchHeader query={searchQuery ?? ''} />
          </Wrapper>
        ) : (
          <Breadcrumbs categories={categories} categoryId={category?.categoryId} />
        )} */}

        <div className="relative  sm:px-24 ">
          {(breadCrumbs?.length as any) > 0 && !searchQuery && (
            <div className="px-16">
              <Breadcrumb
                useSeparatorNode
                Separator={<div className="relative top-[2px] text-[#127e57]">{'>'}</div>}
                className="col-span-12 mb-25 w-fit lg:hidden"
                dynamicPadding={true}
                style={{ paddingLeft: '0px' }}
              >
                {/* Filter breadcrumbs to remove "BRANDS" if it's not the last one */}
                {breadCrumbs
                  ?.map((breadCrumb, index) => {
                    // If the breadcrumb is "BRANDS" and it's not the last breadcrumb, remove it
                    if (breadCrumb.name === 'BRANDS' && breadCrumbs.length > index + 1) {
                      return null; // return null to remove it
                    }
                    return breadCrumb;
                  })
                  .filter(Boolean) // Filter out null values
                  .map((breadCrumb) => {
                    const isActive = pathname === breadCrumb?.href;
                    return (
                      <Link
                        key={breadCrumb?.href}
                        link={breadCrumb?.href}
                        className={`text-14 font-normal ${
                          isActive ? 'font-semibold text-primary-black' : 'text-secondary-grey'
                        }`}
                      >
                        {breadCrumb?.name}
                      </Link>
                    );
                  })}
              </Breadcrumb>
            </div>
          )}

          <div className="mb-25 flex justify-center lg:hidden ">
            <h1 className="font-body text-29 font-semibold leading-[29px]">{currentCategory?.name}</h1>
          </div>
          {/* New DesktopFacets based on the Prod UI */}
          {/* <MobileFacets facetsConfiguration={facetsConfiguration} /> */}
          {/* New DesktopFacets based on the Prod UI */}
          <DesktopFacetsUpdate
            facetsConfiguration={facetsConfiguration}
            breadCrumbs={breadCrumbs}
            searchQuery={searchQuery}
            currentCategory={currentCategory}
            // BrandAndSubCategory={BrandAndSubCategory}
            isNotFound={results?.nbHits > 0}
            nameOfCategory={topAndBottomContent?.name}
          />
          {/* As of now Commented : Referred UI from prod */}
          {/* <DesktopFacets facetsConfiguration={facetsConfiguration} /> */}
          {/* <CurrentRefinements /> */}
          {/* {breadCrumbs?.length > 0 && !searchQuery && (
            <Breadcrumb
              useSeparatorNode
              Separator={<div className="relative top-[2px] text-[#127e57]">{'>'}</div>}
              className="col-span-12 mb-24 w-fit"
            >
              {breadCrumbs.map((breadCrumb) => {
                const isActive = pathname == breadCrumb.href;
                return (
                  <Link
                    key={breadCrumb.href}
                    link={breadCrumb.href}
                    className={`text-14 font-normal ${
                      isActive ? 'font-semibold text-primary-black' : 'text-secondary-grey'
                    }`}
                  >
                    {breadCrumb.name}
                  </Link>
                );
              })}
            </Breadcrumb>
          )} */}
          {/* {brandAndSubCategory && (
            <>
              <p className="mb-30 text-center text-30 font-bold">CATEGORIES</p>

              <div className="mb-50 grid grid-cols-4 gap-4">
                {brandAndSubCategory?.subCategories?.map((i: SubCategories, index: number) => (
                  <>
                    <Link link={`${i?.name}`}>
                      <div className="flex h-full items-center justify-start p-2" key={index}>
                        <ArrowIcon className="mt-2 w-15 stroke-[#127e57]" /> {`${i?.name} (${i?.productsCount})`}
                      </div>
                    </Link>
                  </>
                ))}
              </div>
            </>
          )} */}
          {
            <div className="clear-filters-container my-10 block px-16 lg:hidden">
              <input
                type="button"
                className="cursor-pointer rounded-md bg-[#1dce8f] p-5 text-13 font-semibold"
                value="Clear Filter"
                onClick={clearAllFilters}
              />
            </div>
          }
          {
            <div className="mobile section flex items-center justify-between px-15 pb-16 lg:hidden">
              <div>
                <button
                  className="flex min-w-[80px] cursor-pointer items-center gap-8 rounded-md border border-transparent bg-white px-12 py-6 text-14 leading-[20px] transition hover:border-gray-500"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <FiltersIcon className="mt-2 w-16 stroke-green-600" />
                  <span className="text-14">
                    {formatProductMessage({ id: 'sortAndFilter', defaultMessage: 'Filter' })}
                  </span>
                </button>
              </div>
              {results.nbHits > 0 && <SortBy />}
            </div>
          }
          {/* {isLoading && <Loading />} */}
          <>
            {' '}
            {results.nbHits > 0 && (
              <div className="clear-filters-container hidden lg:block">
                <input
                  type="button"
                  className="cursor-pointer rounded-md bg-[#1dce8f] p-5 text-13 font-semibold"
                  value="Clear Filter"
                  onClick={clearAllFilters}
                />
              </div>
            )}
            {serverData.length < 0 && <NotFound slug={currentCategory?.name} />}
            <div className="grid grid-cols-1 gap-2 lg:mx-auto lg:grid-cols-[20%_80%] lg:gap-4">
              <div className={`section-1 px-15 lg:block lg:px-0 ${isOpen ? 'block' : 'hidden'}`}>
                {
                  <>
                    {' '}
                    {/* {filteredAttributes?.map((i: string, index: number) => {
                      // console.log('iiiiiiiiii', i);
                      return (
                        <div key={index}>
                          <FacetUI
                            attribute={i}
                            label={i}
                            lowPrice={lowPrice}
                            maxPrice={maxPrice}
                            algoliaMin={algoliaMin}
                            algoliaMax={algoliaMax}
                            priceRange={priceRange}
                            handleOnChange={handleOnChange}
                            handleFinalChange={handleFinalChange}
                          />
                          <FacetWidget attribute={i} />
                        </div>
                      );
                    })} */}
                    {attributesToRender?.map((attribute) => {
                      if (attribute === 'variants.attributes.colour') {
                        return null;
                      }
                      if (attribute === priceAttributes && lowPrice !== maxPrice) {
                        return (
                          <div key={attribute} className="border-0 border-neutral-400 lg:border-b">
                            <AccordionBtn
                              variant="plusAndMinus"
                              className="text-16 font-bold leading-7"
                              closedSectionTitle="PRICE RANGE"
                              buttonClassName="pt-15 font-bold text-16 leading-tight text-primary-black border-neutral-400"
                              panelClassName="pb-15"
                              defaultOpen={true}
                              sectionTileClassName="font-body text-16 font-bold uppercase leading-[28px]"
                            >
                              <div className="p-4 py-10">
                                <RangeSlider attribute={priceAttributes} />
                              </div>
                            </AccordionBtn>
                          </div>
                        );
                      }
                      // if (attribute === 'categories.en-GB.lvl1') {
                      //   return (
                      //     <AccordionBtn
                      //       key={attribute}
                      //       variant="plusAndMinus"
                      //       className="font-body text-16 font-bold uppercase leading-[28px]"
                      //       closedSectionTitle={attributeMapping?.[attribute]}
                      //       sectionTileClassName="font-body text-16 font-bold uppercase leading-[28px]"
                      //       buttonClassName="py-15 font-bold text-16 leading-[28px] font-body uppercase"
                      //       panelClassName="pb-15"
                      //       defaultOpen={true}
                      //     >
                      //       <div>
                      //         <RefinementList
                      //           key={attribute}
                      //           classNames={{
                      //             list: 'space-y-2',
                      //             item: 'flex items-center w-full',
                      //             checkbox:
                      //               'w-19 h-19 mr-8 border border-gray-300 mt-1 rounded-sm bg-white shadow-inner focus:outline-none',
                      //             label: 'flex w-full justify-between items-center',
                      //             labelText: 'text-16 flex-grow hover:text-[#127E57]',
                      //             count: 'text-16 text-gray-500 before:content-["("] after:content-[")"]',
                      //             showMore: `mt-10 text-center w-full block text-16 hover:text-[#127E57] ${
                      //               shouldShowMore(attribute) ? '' : 'hidden'
                      //             }`,
                      //           }}
                      //           showMore={shouldShowMore(attribute)}
                      //           limit={limit}
                      //           showMoreLimit={showMoreLimit}
                      //           transformItems={transformItems}
                      //           translations={{
                      //             showMoreButtonText: ({ isShowingMore }) =>
                      //               isShowingMore ? '- Collapse' : '+ Show more',
                      //           }}
                      //           attribute={attribute}
                      //         />
                      //       </div>
                      //     </AccordionBtn>
                      //   );
                      // }
                      return (
                        <AccordionBtn
                          key={attribute}
                          variant="plusAndMinus"
                          className="font-body text-16 font-bold uppercase leading-[28px]"
                          closedSectionTitle={attributeMapping?.[attribute]}
                          sectionTileClassName="font-body text-16 font-bold uppercase leading-[28px]"
                          buttonClassName="py-15 font-bold text-16 leading-[28px] font-body uppercase"
                          panelClassName="pb-15"
                          defaultOpen={true}
                        >
                          <div>
                            <RefinementList
                              key={attribute}
                              classNames={{
                                list: 'space-y-2',
                                item: 'flex items-center w-full',
                                checkbox:
                                  'w-19 h-19 mr-8 border border-gray-300 mt-1 rounded-sm bg-white shadow-inner focus:outline-none',
                                label: 'flex w-full justify-between items-center',
                                labelText: 'text-16 flex-grow hover:text-[#127E57]',
                                count: 'text-16 text-gray-500 before:content-["("] after:content-[")"]',
                                showMore: `mt-10 text-center w-full block text-16 hover:text-[#127E57] ${
                                  shouldShowMore(attribute) ? '' : 'hidden'
                                }`,
                              }}
                              showMore={shouldShowMore(attribute)}
                              limit={limit}
                              showMoreLimit={showMoreLimit}
                              attribute={attribute}
                              translations={{
                                showMoreButtonText: ({ isShowingMore }) =>
                                  isShowingMore ? '- Collapse' : '+ Show more',
                              }}
                              transformItems={transformItems}
                            />
                          </div>
                        </AccordionBtn>
                      );
                    })}
                  </>
                }
              </div>

              {
                <div className="section-2">
                  <div className="border-3 grid grid-cols-2 border border-[#f5f4f3] md:grid-cols-3 md:gap-10 md:border-none lg:grid-cols-3 lg:gap-24">
                    {serverData?.map((hit) => {
                      return (
                        <ProductListTile
                          key={hit?.objectID}
                          product={mapProduct(hit, locale)}
                          isSearchResult={!!searchQuery}
                          onClick={() => gtag('event', PLP_PRODUCT_CLICKED, hit)}
                          handleCompareChange={handleCompareChange}
                          setOpen={setOpen}
                          compareProduct={productsToCompare}
                          badgeData={badgeData}
                          slug={slug}
                        />
                      );
                    })}
                  </div>
                  <AccumalativeTrace />
                  {/* <button
                    onClick={() => {
                      showMore();
                      handleClickLoadMore(locale);
                    }}
                    disabled={hits?.length >= totalHits}
                    className="mx-auto mt-[90px] block rounded-md bg-primary-black px-48 py-12 text-16 font-bold text-white transition hover:bg-gray-500 disabled:bg-neutral-400 disabled:opacity-0"
                  >
                    LOAD MORE
                  </button> */}

                  <SmartLink
                    callback={() => {
                      const url = new URL(window.location.href);
                      const current = parseInt(url.searchParams.get('page') || '1', 10);
                      url.searchParams.set('page', String(current + 1));
                      return url.pathname + '?' + url.searchParams.toString();
                    }}
                  >
                    {button}
                  </SmartLink>

                  {productsToCompare?.length !== 0 && (
                    <Modal
                      isOpen={open}
                      style={{ content: { maxWidth: '1200px', height: '572px', bottom: 0, right: 0 } }}
                    >
                      <div className="flex items-center justify-end">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          width="15"
                          height="15"
                          viewBox="0 0 48 48"
                        >
                          <path fill="#F44336" d="M21.5 4.5H26.501V43.5H21.5z" transform="rotate(45.001 24 24)"></path>
                          <path fill="#F44336" d="M21.5 4.5H26.5V43.501H21.5z" transform="rotate(135.008 24 24)"></path>
                        </svg>
                        <input type="button" onClick={() => setOpen(false)} value={'Close'} />
                      </div>
                      <div>
                        <div className="m-15 flex w-full justify-evenly">
                          <div className={`flex h-[493px] w-[240px] flex-col items-center  border-slate-700`}>
                            <img src={productsToCompare?.[0]?.variants?.[0]?.images?.[0]} className="" />
                            <hr className="my-2 w-full border-t border-slate-500" />

                            <p className="mb-20 mt-10 h-59  w-full text-center text-22 font-bold leading-[22px]">
                              {productsToCompare?.[0]?.name}
                            </p>

                            {/* <div className="mb-10 py-7">
                              <TrustBox id={trustPilotSkuId} showVertical={false} />
                            </div> */}

                            <div className="mt-20">
                              <Price
                                prices={productsToCompare?.[0]?.standalonePrice}
                                discountedPrice={productsToCompare?.[0]?.discountedPrice}
                              />
                            </div>
                            <hr className="my-2 mt-20 w-full border-t border-slate-500" />
                            <div className="mt-20 flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="15"
                                height="15"
                                viewBox="0 0 48 48"
                              >
                                <path
                                  fill="#F44336"
                                  d="M21.5 4.5H26.501V43.5H21.5z"
                                  transform="rotate(45.001 24 24)"
                                ></path>
                                <path
                                  fill="#F44336"
                                  d="M21.5 4.5H26.5V43.501H21.5z"
                                  transform="rotate(135.008 24 24)"
                                ></path>
                              </svg>
                              <input
                                type="button"
                                onClick={() => removeProductFromSession(productsToCompare?.[0]?.productKey)}
                                value={'Remove'}
                                className="cursor-pointer"
                              />
                            </div>
                          </div>

                          {beforeCompare?.beforeCompare?.map((item, index) => {
                            const product = productsToCompare?.[index + 1];

                            return (
                              <div
                                key={index}
                                className="flex h-[493px] w-[240px] flex-col items-center justify-center "
                              >
                                {product ? (
                                  <>
                                    <div className={`flex h-[493px] w-[240px] flex-col items-center  border-slate-700`}>
                                      <img src={product?.variants?.[0]?.images?.[0]} className="" />
                                      <hr className="my-2 w-full border-t border-slate-500" />
                                      <p className="mb-20 mt-10 h-59 w-full text-center text-22 font-bold leading-[22px] ">
                                        {product?.name}
                                      </p>
                                      <div className="mb-10 py-7">
                                        <TrustBox id={trustPilotSkuId} showVertical={false} />
                                      </div>
                                      <div className="mt-20">
                                        <Price
                                          prices={product?.standalonePrice}
                                          discountedPrice={product?.discountedPrice}
                                        />
                                      </div>
                                      <hr className="my-2 mt-20 w-full border-t border-slate-500" />
                                      <div className="mt-20 flex  items-center">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          x="0px"
                                          y="0px"
                                          width="15"
                                          height="15"
                                          viewBox="0 0 48 48"
                                        >
                                          <path
                                            fill="#F44336"
                                            d="M21.5 4.5H26.501V43.5H21.5z"
                                            transform="rotate(45.001 24 24)"
                                          ></path>
                                          <path
                                            fill="#F44336"
                                            d="M21.5 4.5H26.5V43.501H21.5z"
                                            transform="rotate(135.008 24 24)"
                                          ></path>
                                        </svg>
                                        <input
                                          onClick={() => removeProductFromSession(product?.productKey)}
                                          className="cursor-pointer"
                                          type="button"
                                          value={'Remove'}
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div
                                    key={index}
                                    className="flex h-[493px] w-[240px] flex-col items-center justify-center border-2 border-dashed border-slate-700"
                                  >
                                    <div className="text-42 font-semibold">{item?.number}</div>
                                    <p className="text-center text-16 font-normal">
                                      <span
                                        className="mr-2 cursor-pointer underline underline-offset-4"
                                        onClick={() => setOpen(false)}
                                      >
                                        Select
                                      </span>
                                      {item?.text}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>

                        <div className="flex  justify-end ">
                          <input
                            type="button"
                            className="h-[39px] w-[130px] cursor-pointer bg-[#1DCE8F] text-14"
                            onClick={comparePage}
                            value={'COMPARE NOW'}
                          />
                        </div>
                      </div>
                    </Modal>
                  )}
                </div>
              }
            </div>
          </>
          {/* {!BrandAndSubCategory && <AccumalativeTrace />} */}
        </div>
        {/* {brandAndSubCategory && (
          <>
            <p className="mb-30 text-center text-30 font-bold">BRANDS</p>

            <div className="mb-50 ml-30 grid grid-cols-4 gap-4">
              {brandAndSubCategory?.brands?.map((i: Brands, index: number) => (
                <Link link={`${i?.brand}`} key={index}>
                  <div className="flex h-full items-center justify-start p-2">
                    {' '}
                    <ArrowIcon className="mt-2 w-15 stroke-[#127e57]" /> {`${i?.brand} (${i?.productsCount})`}{' '}
                  </div>
                </Link>
              ))}
            </div>
          </>
        )} */}
        {topAndBottomContent?.bottomContent && (
          <>
            {topAndBottomContent?.bottomContent?.length > 0 && (
              <div className="bottomContent-section flex items-center justify-center px-4 py-10 sm:px-6 lg:px-8">
                <div className="w-[930px] items-center">
                  {topAndBottomContent?.bottomContent?.map((content: BottomContentDescription, index: number) => (
                    <div
                      key={index}
                      className={`content-item ${
                        index > 0 && !isExpanded ? 'hidden' : ''
                      } flex flex-col items-center gap-y-6`}
                    >
                      <h2 className="mb-20 mt-16 text-4xl font-bold">{content?.heading}</h2>
                      <MarkDownDescription markdownText={content?.description} classname="" />
                    </div>
                  ))}
                  <div className="mt-10 flex items-center justify-center">
                    {topAndBottomContent?.bottomContent.length > 1 && (
                      <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center gap-x-3">
                        {isExpanded ? (
                          <>
                            <span className="font-body text-16 font-medium">Read Less</span>
                            <span className="text-30 font-normal leading-7 text-[#127e57]">-</span>
                          </>
                        ) : (
                          <>
                            <span className="font-body text-16 font-medium">Read More</span>
                            <span className="text-30 font-normal leading-7 text-[#127e57]">+</span>
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {topAndBottomContent?.frequentlyAskedQuestions && (
          <FaqAmplience faqContent={topAndBottomContent?.frequentlyAskedQuestions} />
        )}
        {/* As of commentted : Need to Fix */}
        {/* <Faq categories={categories} /> */}
      </div>
    </>
  );
};

export default ProductListAlgolia;
